import { tribesActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case tribesActionTypes.SET_TRIBES:
            return action.tribes;
        case tribesActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};